/* D-TAIL LAB — Policy Consent v2.0 + Delivery Signature & Drop-off Authorization v1.3.3
   v1.3.3 (2026-10-22) :
   [A] Champs lisibles (dtail_policy_display / dtail_signature_display) : suffixes
       dtpa_/dtsa_ RETIRÉS — statut, lieu, langue, version et horodatage conservés.
       Les identifiants complets restent dans les attributs techniques et les preuves.
   [B] Note de commande (computeDeliveryNote) : phrases lisibles dans la langue de la
       commande, libellés de lieu traduits (plus de codes front_door/side_entrance),
       plus de « REF dtsa_ » ; lignes EN inchangées ; libres « DELIVERY: » préservées.
   [C] Allemand (de) publié : TEXTS/SIG_TEXTS/validation/affichage. Repli EXPLICITE :
       langue non prise en charge → texte EN affiché ET enregistré comme EN (jamais de
       faux consentement EN : la langue enregistrée correspond au texte affiché).
   Architecture : fail-closed
   Source de vérité : cart attribute _dtail_policy_acceptance (caché dans Shopify Admin)
   Format : accepted|LANG|v1.2|ISO_TIMESTAMP|dtpa_xxxxxx
   Chargé UNE SEULE FOIS depuis layout/theme.liquid (global)

   v2.0 (2026-10-19) :
   [V13] Signature/dépôt v1.3 : question « signature à la livraison », lieu de dépôt
         (codes stables), précisions ≤250, autorisation explicite distincte, récap,
         nettoyage panier vide. Texte politique d'acceptation → v1.2 (synchronisé JS/Liquid).
   Corrections v1.5 :
   [1] parseAcceptanceAttr() + sendExternal(attrValue) — accepted_at = timestamp exact
       du cart attribute, pas new Date(). Tout dérivé depuis attrValue.
   [2] confirmFinalAcceptance(attrValue) — fonction centralisée unique
       Utilisée dans saveToCart, Règle B, Règle C. sendExternal garanti dans tous ces chemins.
   [3] reconcileAfterError() bornée (MAX_RETRY=3) + sessionStorage pending_clear
       Toute erreur ambiguë déclenche relecture + réessai. pending_clear bloque
       la restauration d'une suppression non confirmée après actualisation.
   [4] Listener change attaché IMMÉDIATEMENT dans initGate(), avant ensureRestored().
       ensureRestored callback ne sync que si operationVersion est inchangée.
   [5] pendingOperation = { type, version } + clearPendingOperation(version)
       Une ancienne opération ne peut pas remettre pendingOperation à null
       si une opération plus récente est active.
   [6] pending_clear retiré dans confirmFinalAcceptance après confirmation exacte
*/
(function () {
  'use strict';

  if (window.__dtailPolicyInit) return;
  window.__dtailPolicyInit = true;

  /* ── CONSTANTES ──────────────────────────────────────────────────── */
  var ATTR_KEY          = '_dtail_policy_acceptance';
  var POLICY_VERSION    = 'v1.2';
  var EXT_ENDPOINT      = 'https://dscope-dashboard.misty-dust-9bc3.workers.dev/api/policy-record';
  var DTPA_REGEX        = /^dtpa_[a-z0-9_]{4,}$/i;
  var ISO_REGEX         = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;
  var MAX_RETRY         = 3;
  var PENDING_CLEAR_KEY = 'dtail_policy_pending_clear';

  /* ── SIGNATURE v1.3 — constantes séparées de la politique v1.2 ── */
  var SIGNATURE_VERSION  = 'v1.3';
  var SIG_ATTR_KEY       = '_dtail_signature_authorization';
  var SIG_DISPLAY_KEY    = 'dtail_signature_display';
  var SIG_SOURCE_KEY     = '_dtail_signature_source';
  var DROP_ATTR_LOCATION = '_dtail_dropoff_location';
  var DROP_ATTR_DETAILS  = '_dtail_dropoff_details';
  var DROP_ATTR_CONSENT  = '_dtail_dropoff_consent';
  var DTSA_REGEX         = /^dtsa_[a-z0-9_]{4,}$/i;
  /* v1.3.3 — lignes de note par langue. EN inchangées byte-for-byte (dépendances
     opérationnelles). FR/ES/DE : phrases lisibles dans la langue de la commande. */
  var NOTE_TEXTS = {
    en: { yes: 'DELIVERY: NO SIGNATURE AUTHORIZED BY CUSTOMER',
          no:  'DELIVERY: SIGNATURE REQUIRED',
          drop:'DELIVERY DROP-OFF: ' },
    fr: { yes: 'LIVRAISON : DÉPÔT SANS SIGNATURE AUTORISÉ PAR LE CLIENT',
          no:  'LIVRAISON : SIGNATURE REQUISE',
          drop:'DÉPÔT : ' },
    es: { yes: 'ENTREGA: PAQUETE DEJADO SIN FIRMA, AUTORIZADO POR EL CLIENTE',
          no:  'ENTREGA: FIRMA REQUERIDA',
          drop:'LUGAR DE ENTREGA: ' },
    de: { yes: 'LIEFERUNG: ABSTELLUNG OHNE UNTERSCHRIFT VOM KUNDEN ERLAUBT',
          no:  'LIEFERUNG: UNTERSCHRIFT ERFORDERLICH',
          drop:'ABSTELLORT: ' }
  };
  var LOCATION_CODES     = ['front_door','back_door','side_entrance','parcel_box','other'];
  var DETAILS_REQUIRED_FOR = ['other'];
  var DETAILS_VISIBLE_FOR  = ['other'];
  var DETAILS_MAX        = 250;

  /* Helper URL Cart API — respecte la langue du parcours (Shopify.routes.root) */
  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '';
    return String(root).replace(/\/$/, '') + path;
  }

  /* ── TEXTES — apostrophes U+2019 identiques HTML et JS ──────────── */
  var TEXTS = {
    fr: {
      fullText:       'J\u2019ai lu et j\u2019accepte la politique de livraison de D-TAIL LAB. Je v\u00e9rifierai mon adresse de livraison avant de confirmer ma commande. Mes droits pr\u00e9vus par les lois applicables demeurent inchang\u00e9s.',
      linkHref:       'https://dtaillab.com/fr/policies/shipping-policy',
      errorRequired:  'Veuillez accepter la politique de livraison avant de continuer.',
      errorTechnical: 'Une erreur est survenue pendant l\u2019enregistrement de votre acceptation. Veuillez r\u00e9essayer avant de continuer.',
      errorSaving:    'Enregistrement en cours\u2026 veuillez patienter.'
    },
    en: {
      fullText:       'I have read and accept D-TAIL LAB\u2019s shipping policy. I will verify my shipping address before confirming my order. My rights under applicable law remain unchanged.',
      linkHref:       'https://dtaillab.com/policies/shipping-policy',
      errorRequired:  'Please accept the shipping policy before continuing.',
      errorTechnical: 'An error occurred while saving your acceptance. Please try again before continuing.',
      errorSaving:    'Saving… please wait a moment.'
    },
    es: {
      fullText:       'He le\u00eddo y acepto la pol\u00edtica de env\u00edo de D-TAIL LAB. Verificar\u00e9 mi direcci\u00f3n de env\u00edo antes de confirmar mi pedido. Mis derechos conforme a las leyes aplicables permanecen sin cambios.',
      linkHref:       'https://dtaillab.com/es/policies/shipping-policy',
      errorRequired:  'Acepte la pol\u00edtica de env\u00edo antes de continuar.',
      errorTechnical: 'Ocurri\u00f3 un error al guardar su aceptaci\u00f3n. Int\u00e9ntelo de nuevo antes de continuar.',
      errorSaving:    'Guardando\u2026 espere un momento.'
    },
    de: {
      fullText:       'Ich habe die Versandrichtlinie von D-TAIL LAB gelesen und akzeptiere sie. Ich werde meine Lieferadresse überprüfen, bevor ich meine Bestellung bestätige. Meine Rechte nach geltendem Recht bleiben unverändert.',
      linkHref:       'https://dtaillab.com/de/policies/shipping-policy',
      errorRequired:  'Bitte akzeptieren Sie die Versandrichtlinie, bevor Sie fortfahren.',
      errorTechnical: 'Beim Speichern Ihrer Zustimmung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut, bevor Sie fortfahren.',
      errorSaving:    'Speichern l\u00e4uft\u2026 bitte warten.'
    }
  };

  /* ── TEXTES SIGNATURE + DÉPÔT v1.3 (EN/FR/ES) — erreurs + récap ── */
  var SIG_TEXTS = {
    en: {
      errorRequired:   'Please choose whether you want a signature on delivery before continuing.',
      errorTechnical:  'An error occurred while saving your delivery preference. Please try again before continuing.',
      errorSaving:     'Saving… please wait a moment.',
      errorLocation:   'Please choose where you authorize the parcel to be left.',
      errorDetails:    'Please specify the location (required for this choice).',
      errorConsent:    'Please check the authorization box to confirm delivery without a signature.',
      summarySaved:    'Saved',
      summarySignature:'Signature requested on delivery.',
      summaryDropoff:  'Delivery without a signature authorized.',
      summaryLocation: 'Drop-off location',
      summaryDetails:  'Details',
      locationLabels:  { front_door: 'Front door', back_door: 'Back door', side_entrance: 'Side entrance', parcel_box: 'Parcel box', other: 'Other location' }
    },
    fr: {
      errorRequired:   'Veuillez indiquer si vous souhaitez ou non une signature à la livraison avant de continuer.',
      errorTechnical:  'Une erreur est survenue pendant l\u2019enregistrement de votre préférence de livraison. Veuillez réessayer avant de continuer.',
      errorSaving:     'Enregistrement en cours… veuillez patienter.',
      errorLocation:   'Veuillez choisir l\u2019endroit où vous autorisez le dépôt du colis.',
      errorDetails:    'Veuillez préciser l\u2019endroit (obligatoire pour ce lieu).',
      errorConsent:    'Veuillez cocher la case d\u2019autorisation pour confirmer le dépôt sans signature.',
      summarySaved:    'Choix enregistré',
      summarySignature:'Livraison avec signature demandée.',
      summaryDropoff:  'Dépôt sans signature autorisé.',
      summaryLocation: 'Lieu de dépôt',
      summaryDetails:  'Précisions',
      locationLabels:  { front_door: 'Porte principale / avant', back_door: 'Porte arrière', side_entrance: 'Entrée latérale', parcel_box: 'Boîte à colis', other: 'Autre endroit' }
    },
    es: {
      errorRequired:   'Indique si desea o no una firma en la entrega antes de continuar.',
      errorTechnical:  'Se produjo un error al guardar su preferencia de entrega. Inténtelo de nuevo antes de continuar.',
      errorSaving:     'Guardando… espere un momento.',
      errorLocation:   'Elija el lugar donde autoriza que se deje el paquete.',
      errorDetails:    'Especifique el lugar (obligatorio para esta opción).',
      errorConsent:    'Marque la casilla de autorización para confirmar la entrega sin firma.',
      summarySaved:    'Preferencia guardada',
      summarySignature:'Entrega con firma solicitada.',
      summaryDropoff:  'Entrega sin firma autorizada.',
      summaryLocation: 'Lugar de entrega',
      summaryDetails:  'Detalles',
      locationLabels:  { front_door: 'Puerta principal / frontal', back_door: 'Puerta trasera', side_entrance: 'Entrada lateral', parcel_box: 'Buzón de paquetes', other: 'Otro lugar' }
    },
    de: {
      errorRequired:   'Bitte geben Sie an, ob Sie bei der Lieferung eine Unterschrift wünschen, bevor Sie fortfahren.',
      errorTechnical:  'Beim Speichern Ihrer Liefereinstellung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut, bevor Sie fortfahren.',
      errorSaving:     'Speichern läuft… bitte warten.',
      errorLocation:   'Bitte wählen Sie aus, wo das Paket hinterlassen werden darf.',
      errorDetails:    'Bitte geben Sie den Ort genauer an (für diese Auswahl erforderlich).',
      errorConsent:    'Bitte aktivieren Sie das Kontrollkästchen, um die Lieferung ohne Unterschrift zu bestätigen.',
      summarySaved:    'Gespeichert',
      summarySignature:'Lieferung mit Unterschrift gewünscht.',
      summaryDropoff:  'Lieferung ohne Unterschrift genehmigt.',
      summaryLocation: 'Abladeort',
      summaryDetails:  'Details',
      locationLabels:  { front_door: 'Haustür', back_door: 'Hintertür', side_entrance: 'Seiteneingang', parcel_box: 'Paketbox', other: 'Anderer Ort' }
    }
  };

  /* ── ÉTAT GLOBAL UNIQUE ──────────────────────────────────────────── */
  var policyState = {
    desiredAccepted:   false,
    desiredAttrValue:  null,
    verified:          false,
    attrValue:         null,
    acceptanceId:      null,
    lang:              'en',
    operationVersion:  0,
    restoreStarted:    false,
    restorePromise:    null,
    initialized:       false,
    /* [FIX 5] { type: string, version: number } | null */
    pendingOperation:  null,
    /* [FIX 6] true pendant saveToCart — bloque checkout avec message d'attente */
    isSaving:          false,
    _pendingSubmit:    false
  };

  /* ── UTILITAIRES ─────────────────────────────────────────────────── */
  var SUPPORTED_LANGS = ['en', 'fr', 'es', 'de'];
  /* v1.3.3 — repli EXPLICITE : une langue non prise en charge est affichée ET
     enregistrée comme EN. Le texte affiché au client EST l'anglais : la langue
     enregistrée correspond toujours au texte réellement accepté. Une langue non
     reconnue n'est jamais présentée comme un consentement EN pris ailleurs. */
  function normalizeLang(l) {
    var s = String(l || '').toLowerCase();
    if (s.indexOf('fr') === 0) return 'fr';
    if (s.indexOf('es') === 0) return 'es';
    if (s.indexOf('de') === 0) return 'de';
    if (s.indexOf('en') === 0) return 'en';
    console.warn('[dtail-policy] locale non prise en charge (' + l + ') — repli explicite EN : texte affiché et enregistré = EN');
    return 'en';
  }

  function genId() {
    return 'dtpa_' + Math.random().toString(36).substring(2, 10) + '_' + Date.now().toString(36);
  }

  function buildAttrValue(lang, id) {
    return 'accepted|' + lang + '|' + POLICY_VERSION + '|' + new Date().toISOString() + '|' + id;
  }

  function isValidAttr(val) {
    if (!val || typeof val !== 'string') return false;
    var parts = val.split('|');
    if (parts.length !== 5)                     return false;
    if (parts[0] !== 'accepted')                return false;
    if (SUPPORTED_LANGS.indexOf(parts[1]) === -1) return false;   /* v1.3.3 : + de */
    if (parts[2] !== POLICY_VERSION)            return false;
    if (!ISO_REGEX.test(parts[3]))              return false;
    if (isNaN(Date.parse(parts[3])))            return false;
    if (!DTPA_REGEX.test(parts[4]))             return false;
    return true;
  }

  /* [FIX 1] parseAcceptanceAttr — retourne null si invalide */
  function parseAcceptanceAttr(attrValue) {
    if (!isValidAttr(attrValue)) return null;
    var parts = attrValue.split('|');
    return {
      status:        parts[0],
      language:      parts[1],
      policyVersion: parts[2],
      acceptedAt:    parts[3],   /* timestamp EXACT du cart attribute */
      acceptanceId:  parts[4]
    };
  }

  /* [FIX 5] pendingOperation versionnée */
  function setPendingOperation(type, version) {
    policyState.pendingOperation = { type: type, version: version };
  }

  function clearPendingOperation(version) {
    if (policyState.pendingOperation && policyState.pendingOperation.version === version) {
      policyState.pendingOperation = null;
    }
  }

  function isOperationActive() {
    return policyState.pendingOperation !== null;
  }

  /* ── SYNC VISUELLE ───────────────────────────────────────────────── */
  function syncAllCheckboxes(checked) {
    document.querySelectorAll('.dtail-policy-checkbox').forEach(function (cb) {
      cb.checked = checked;
    });
  }

  /* ── CART HELPERS ────────────────────────────────────────────────── */
  function getEtOffset(dtUtc) {
    /* Calcul dynamique UTC-4 (EDT) ou UTC-5 (EST) selon règles nord-américaines
       Heure d’été : 2e dimanche de mars → 1er dimanche de novembre */
    var y = dtUtc.getUTCFullYear();
    /* 2e dimanche de mars à 02:00 EST (07:00 UTC) */
    var mar1     = new Date(Date.UTC(y, 2, 1));
    var dstStart = new Date(Date.UTC(y, 2, 14 - ((mar1.getUTCDay() + 6) % 7), 7));
    /* 1er dimanche de novembre à 02:00 EDT (06:00 UTC) */
    var nov1     = new Date(Date.UTC(y, 10, 1));
    var dow      = nov1.getUTCDay(); // 0=dim
    var dstEnd   = new Date(Date.UTC(y, 10, (dow === 0 ? 1 : 8 - dow), 6));
    return (dtUtc >= dstStart && dtUtc < dstEnd) ? -4 : -5;
  }

  function buildDisplayAttr(attrValue) {
    /* Construit la version lisible (EDT/EST) à partir de l’attrValue technique */
    try {
      var parts = attrValue.split('|');
      if (parts.length < 5) return null;
      var lang    = parts[1];           // 'fr' ou 'en'
      var version = parts[2];           // 'v1.1'
      var tsUtc   = parts[3];           // ISO UTC
      var id      = parts[4];           // dtpa_xxx
      var dtUtc   = new Date(tsUtc);
      var offset  = getEtOffset(dtUtc); // -4 (EDT) ou -5 (EST)
      var etMs    = dtUtc.getTime() + (offset * 60 * 60 * 1000);
      var etDate  = new Date(etMs);
      var tz      = (offset === -4) ? 'EDT' : 'EST';
      var pad     = function(n) { return String(n).padStart(2, '0'); };
      var fmtDate = etDate.getUTCFullYear() + '-'
                  + pad(etDate.getUTCMonth() + 1) + '-'
                  + pad(etDate.getUTCDate()) + ' '
                  + pad(etDate.getUTCHours()) + ':'
                  + pad(etDate.getUTCMinutes()) + ':'
                  + pad(etDate.getUTCSeconds()) + ' ' + tz;
      var word    = { fr: 'Accepté', en: 'Accepted', es: 'Aceptado', de: 'Akzeptiert' }[lang] || 'Accepted';
      var langUp  = lang.toUpperCase();
      /* v1.3.3 — l'identifiant dtpa_ ne figure plus dans le champ lisible ;
         il reste dans _dtail_policy_acceptance et dans les preuves persistées. */
      return word + ' · ' + langUp + ' · ' + version + ' · ' + fmtDate;
    } catch (e) { return null; }
  }

  /* v1.3.1 — SÉRIALISATION : un seul POST de modification actif à la fois.
     La chaîne garantit qu'une requête déjà envoyée ne peut pas intercaler
     son écriture avec celle d'une intention plus récente. */
  var cartWriteChain = Promise.resolve();
  function queueCartWrite(task) {
    var run = cartWriteChain.then(function () { return task(); }, function () { return task(); });
    cartWriteChain = run.then(function () {}, function () {});
    return run;
  }

  function cartUpdate(attrValue) {
    var body = {};
    body[ATTR_KEY] = attrValue;
    /* Attribut lisible EDT pour affichage dans Shopify Admin */
    var display = buildDisplayAttr(attrValue);
    if (display) body['dtail_policy_display'] = display;
    return queueCartWrite(function () {
      return fetch(cartUrl('/cart/update.js'), {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ attributes: body })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart/update.js HTTP ' + res.status);
        return res.json();
      });
    });
  }

  function cartRead() {
    return fetch(cartUrl('/cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js HTTP ' + res.status);
        return res.json();
      });
  }

  /* [FIX 2] confirmFinalAcceptance — fonction centralisée ─────────── */
  function confirmFinalAcceptance(attrValue) {
    if (!isValidAttr(attrValue)) {
      console.error('[dtail-policy] confirmFinalAcceptance: invalide', attrValue);
      return false;
    }
    if (attrValue !== policyState.desiredAttrValue) {
      console.error('[dtail-policy] confirmFinalAcceptance: mismatch vs desiredAttrValue');
      return false;
    }
    var parsed = parseAcceptanceAttr(attrValue);
    policyState.verified     = true;
    policyState.attrValue    = attrValue;
    policyState.acceptanceId = parsed.acceptanceId;
    syncAllCheckboxes(true);
    try { sessionStorage.removeItem('dtail_policy_pending_clear'); } catch(e) {}
    /* [FIX 1] sendExternal avec timestamp exact — jamais new Date() */
    sendExternal(attrValue);
    return true;
  }

  /* ── UI HELPERS ──────────────────────────────────────────────────── */
  function showError(gate, type) {
    var lang  = normalizeLang(gate.getAttribute('data-lang'));
    var t     = TEXTS[lang] || TEXTS.en;
    var errEl = gate.querySelector('.dtail-policy-error');
    if (!errEl) return;
    if (type === 'saving') {
      errEl.textContent = t.errorSaving;
      errEl.className   = 'dtail-policy-error visible saving';
    } else if (type === 'technical') {
      errEl.textContent = t.errorTechnical;
      errEl.className   = 'dtail-policy-error visible technical';
    } else {
      errEl.textContent = t.errorRequired;
      errEl.className   = 'dtail-policy-error visible';
    }
  }

  function hideError(gate) {
    var errEl = gate.querySelector('.dtail-policy-error');
    if (errEl) errEl.className = 'dtail-policy-error';
  }

  function blockEvent(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  /* [FIX 3] Réconciliation bornée après erreur ambiguë ─────────────── */
  function reconcileAfterError(opVersion, lang, attempt) {
    attempt = attempt || 1;
    if (attempt > MAX_RETRY) {
      console.error('[dtail-policy] reconcileAfterError: MAX_RETRY atteint, verified=false');
      policyState.verified = false;
      syncAllCheckboxes(policyState.desiredAccepted && policyState.verified);
      return;
    }
    if (policyState.operationVersion !== opVersion) return;

    cartRead().then(function (cart) {
      if (policyState.operationVersion !== opVersion) return;
      var shopifyVal = cart.attributes && cart.attributes[ATTR_KEY];

      if (policyState.desiredAccepted) {
        if (shopifyVal === policyState.desiredAttrValue && isValidAttr(shopifyVal)) {
          confirmFinalAcceptance(shopifyVal);
          console.log('[dtail-policy] reconcileAfterError: trouv\u00e9 @ attempt ' + attempt);
        } else {
          cartUpdate(policyState.desiredAttrValue)
            .then(function () { reconcileAfterError(opVersion, lang, attempt + 1); })
            .catch(function () { reconcileAfterError(opVersion, lang, attempt + 1); });
        }
      } else {
        if (shopifyVal && shopifyVal.length > 0) {
          cartUpdate('')
            .then(function () { reconcileAfterError(opVersion, lang, attempt + 1); })
            .catch(function () { reconcileAfterError(opVersion, lang, attempt + 1); });
        } else {
          policyState.verified         = false;
          policyState.attrValue        = null;
          policyState.desiredAttrValue = null;
          policyState.acceptanceId     = null;
          try { sessionStorage.removeItem(PENDING_CLEAR_KEY); } catch(e) {}
          syncAllCheckboxes(false);
          console.log('[dtail-policy] reconcileAfterError: clear confirm\u00e9 @ attempt ' + attempt);
        }
      }
    }).catch(function () {
      reconcileAfterError(opVersion, lang, attempt + 1);
    });
  }

  /* ── RÉCONCILIATION POST-OPÉRATION ───────────────────────────────── */
  function reconcile(opVersion, lang) {
    if (policyState.operationVersion !== opVersion) return;

    cartRead().then(function (cart) {
      if (policyState.operationVersion !== opVersion) return;
      var shopifyVal   = cart.attributes && cart.attributes[ATTR_KEY];
      var shopifyValid = isValidAttr(shopifyVal);

      /* ── RÈGLE A : save parasite ── */
      if (!policyState.desiredAccepted && shopifyValid) {
        console.warn('[dtail-policy] R\u00e8gle A : save parasite — clear forc\u00e9');
        policyState.verified = false;
        var cleanVersion = ++policyState.operationVersion;
        setPendingOperation('reconcile-clear', cleanVersion);
        syncAllCheckboxes(false);
        cartUpdate('').then(function () {
          return cartRead();
        }).then(function (cart2) {
          clearPendingOperation(cleanVersion);
          if (policyState.operationVersion !== cleanVersion) return;
          var v2 = cart2.attributes && cart2.attributes[ATTR_KEY];
          if (v2 && v2.length > 0) {
            console.error('[dtail-policy] R\u00e8gle A : \u00e9chec');
            reconcileAfterError(cleanVersion, lang, 1);
          } else {
            policyState.verified = false; policyState.attrValue = null;
            policyState.desiredAttrValue = null; policyState.acceptanceId = null;
            syncAllCheckboxes(false);
            console.log('[dtail-policy] R\u00e8gle A : OK');
          }
        }).catch(function (err) {
          clearPendingOperation(cleanVersion);
          console.error('[dtail-policy] R\u00e8gle A erreur:', err);
          reconcileAfterError(cleanVersion, lang, 1);
        });
        return;
      }

      /* ── RÈGLE B : clear parasite ── */
      if (policyState.desiredAccepted && !shopifyValid) {
        console.warn('[dtail-policy] R\u00e8gle B : clear parasite — re-save forc\u00e9');
        var reAttrValue = policyState.desiredAttrValue;
        var reId        = policyState.acceptanceId;
        if (!reAttrValue) {
          reId = genId(); reAttrValue = buildAttrValue(lang, reId);
          policyState.desiredAttrValue = reAttrValue; policyState.acceptanceId = reId;
        }
        var reVersion = ++policyState.operationVersion;
        setPendingOperation('reconcile-save', reVersion);
        cartUpdate(reAttrValue).then(function () {
          return cartRead();
        }).then(function (cart2) {
          clearPendingOperation(reVersion);
          if (policyState.operationVersion !== reVersion) return;
          var v2 = cart2.attributes && cart2.attributes[ATTR_KEY];
          /* [FIX 2] confirmFinalAcceptance + sendExternal centralisés */
          if (confirmFinalAcceptance(v2)) {
            console.log('[dtail-policy] R\u00e8gle B : OK, id=' + reId);
          } else {
            console.error('[dtail-policy] R\u00e8gle B : mismatch', v2);
            reconcileAfterError(reVersion, lang, 1);
          }
        }).catch(function (err) {
          clearPendingOperation(reVersion);
          console.error('[dtail-policy] R\u00e8gle B erreur:', err);
          reconcileAfterError(reVersion, lang, 1);
        });
        return;
      }

      /* ── RÈGLE C : valeur Shopify ≠ desiredAttrValue ── */
      if (policyState.desiredAccepted && shopifyValid) {
        if (policyState.desiredAttrValue && shopifyVal !== policyState.desiredAttrValue) {
          console.warn('[dtail-policy] R\u00e8gle C : p\u00e9rim\u00e9e — r\u00e9\u00e9criture de desiredAttrValue');
          var overVersion = ++policyState.operationVersion;
          setPendingOperation('reconcile-save', overVersion);
          cartUpdate(policyState.desiredAttrValue).then(function () {
            return cartRead();
          }).then(function (cart2) {
            clearPendingOperation(overVersion);
            if (policyState.operationVersion !== overVersion) return;
            var v2 = cart2.attributes && cart2.attributes[ATTR_KEY];
            /* [FIX 2] confirmFinalAcceptance + sendExternal centralisés */
            if (confirmFinalAcceptance(v2)) {
              console.log('[dtail-policy] R\u00e8gle C : OK');
            } else {
              console.error('[dtail-policy] R\u00e8gle C : mismatch', v2);
              reconcileAfterError(overVersion, lang, 1);
            }
          }).catch(function (err) {
            clearPendingOperation(overVersion);
            console.error('[dtail-policy] R\u00e8gle C erreur:', err);
            reconcileAfterError(overVersion, lang, 1);
          });
          return;
        }
        /* Valeur correcte — confirmer via fonction centralisée */
        if (!confirmFinalAcceptance(shopifyVal)) {
          console.error('[dtail-policy] R\u00e8gle C : confirm\u00e9 mais mismatch inattendu');
        }
      } else if (!policyState.desiredAccepted && !shopifyValid) {
        policyState.verified = false; policyState.attrValue = null;
        policyState.desiredAttrValue = null; policyState.acceptanceId = null;
        syncAllCheckboxes(false);
      }
    }).catch(function (err) {
      console.error('[dtail-policy] reconcile cartRead:', err);
      reconcileAfterError(opVersion, lang, 1);
    });
  }

  /* ── SAVE TO CART ────────────────────────────────────────────────── */
  function saveToCart(lang, opVersion, callback) {
    var id        = genId();
    var attrValue = buildAttrValue(lang, id);
    policyState.desiredAttrValue = attrValue;
    policyState.acceptanceId     = id;
    setPendingOperation('save', opVersion);

    cartUpdate(attrValue)
      .then(function () {
        if (policyState.operationVersion !== opVersion) throw new Error('stale:save');
        return cartRead();
      })
      .then(function (cart) {
        if (policyState.operationVersion !== opVersion) throw new Error('stale:verify');
        var saved = cart.attributes && cart.attributes[ATTR_KEY];
        if (saved !== policyState.desiredAttrValue) throw new Error('mismatch:save got=' + saved);
        if (!policyState.desiredAccepted) throw new Error('stale:desired-false');

        clearPendingOperation(opVersion);
        /* [FIX 2] confirmFinalAcceptance — sendExternal inclus */
        if (!confirmFinalAcceptance(saved)) throw new Error('confirmFinalAcceptance failed');
        if (callback) callback(null);
        reconcile(opVersion, lang);
      })
      .catch(function (err) {
        clearPendingOperation(opVersion);
        var msg = err && err.message ? err.message : String(err);
        if (msg.indexOf('stale:') === 0) {
          console.log('[dtail-policy] saveToCart annul\u00e9 (' + msg + ')');
          reconcile(policyState.operationVersion, lang);
          return;
        }
        policyState.verified = false;
        console.error('[dtail-policy] saveToCart:', err);
        /* [FIX 3] Réconciliation après erreur ambiguë */
        reconcileAfterError(policyState.operationVersion, lang, 1);
        if (callback) callback(err);
      });
  }

  /* ── CLEAR FROM CART ─────────────────────────────────────────────── */
  function clearFromCart(opVersion, callback) {
    policyState.verified         = false;
    policyState.desiredAttrValue = null;
    policyState.acceptanceId     = null;
    policyState.attrValue        = null;
    setPendingOperation('clear', opVersion);
    syncAllCheckboxes(false);
    /* [FIX 3] Marquer la suppression en session pour survie à l'actualisation */
    try { sessionStorage.setItem(PENDING_CLEAR_KEY, '1'); } catch(e) {}

    cartUpdate('')
      .then(function () {
        if (policyState.operationVersion !== opVersion) throw new Error('stale:clear');
        return cartRead();
      })
      .then(function (cart) {
        if (policyState.operationVersion !== opVersion) throw new Error('stale:clear-verify');
        var val = cart.attributes && cart.attributes[ATTR_KEY];
        if (val && val.length > 0) throw new Error('not-cleared:' + val);
        if (policyState.desiredAccepted) throw new Error('stale:desired-true');

        clearPendingOperation(opVersion);
        policyState.verified = false; policyState.attrValue = null;
        policyState.desiredAttrValue = null; policyState.acceptanceId = null;
        try { sessionStorage.removeItem(PENDING_CLEAR_KEY); } catch(e) {}
        syncAllCheckboxes(false);
        if (callback) callback(null);
        reconcile(opVersion, policyState.lang);
      })
      .catch(function (err) {
        clearPendingOperation(opVersion);
        var msg = err && err.message ? err.message : String(err);
        if (msg.indexOf('stale:') === 0) {
          console.log('[dtail-policy] clearFromCart annul\u00e9 (' + msg + ')');
          reconcile(policyState.operationVersion, policyState.lang);
          return;
        }
        console.error('[dtail-policy] clearFromCart:', err);
        /* [FIX 3] pending_clear reste en session — réconciliation bornée */
        reconcileAfterError(policyState.operationVersion, policyState.lang, 1);
        if (callback) callback(err);
      });
  }

  /* ── RESTAURATION GLOBALE UNIQUE ─────────────────────────────────── */
  function ensureRestored(callback) {
    if (isOperationActive() || policyState.operationVersion > 0) {
      syncAllCheckboxes(policyState.desiredAccepted && policyState.verified);
      if (callback) callback();
      return;
    }

    if (policyState.restoreStarted) {
      policyState.restorePromise.then(function () {
        if (callback) callback();
      }).catch(function () { if (callback) callback(); });
      return;
    }

    policyState.restoreStarted = true;
    policyState.restorePromise = cartRead().then(function (cart) {
      if (isOperationActive() || policyState.operationVersion > 0) {
        syncAllCheckboxes(policyState.desiredAccepted && policyState.verified);
        policyState.initialized = true;
        return;
      }

      var val = cart.attributes && cart.attributes[ATTR_KEY];

      /* [FIX 3] pending_clear : ne pas restaurer une suppression non confirmée */
      var hasPendingClear = false;
      try { hasPendingClear = !!sessionStorage.getItem(PENDING_CLEAR_KEY); } catch(e) {}

      if (hasPendingClear) {
        console.warn('[dtail-policy] restore: pending_clear — suppression forc\u00e9e');
        policyState.desiredAccepted = false; policyState.desiredAttrValue = null;
        policyState.verified = false; policyState.attrValue = null; policyState.acceptanceId = null;
        syncAllCheckboxes(false);
        if (val && val.length > 0) {
          var clearVer = ++policyState.operationVersion;
          setPendingOperation('clear', clearVer);
          cartUpdate('').then(function () {
            return cartRead();
          }).then(function (cart2) {
            clearPendingOperation(clearVer);
            var v2 = cart2.attributes && cart2.attributes[ATTR_KEY];
            if (!v2 || v2.length === 0) {
              try { sessionStorage.removeItem(PENDING_CLEAR_KEY); } catch(e) {}
              console.log('[dtail-policy] restore: pending_clear r\u00e9solu');
            } else {
              console.error('[dtail-policy] restore: \u00e9chec suppression pending_clear');
            }
          }).catch(function (err) {
            clearPendingOperation(clearVer);
            console.error('[dtail-policy] restore: erreur pending_clear', err);
          });
        } else {
          try { sessionStorage.removeItem(PENDING_CLEAR_KEY); } catch(e) {}
        }
        policyState.initialized = true;
        return;
      }

      if (isValidAttr(val)) {
        var parts = val.split('|');
        /* [FIX 8] Ne PAS restaurer verified automatiquement — le client doit cocher manuellement à chaque visite.
           On garde l'acceptanceId connu pour éviter de réécrire un attr identique, mais la checkbox reste décochée. */
        policyState.desiredAccepted  = false;
        policyState.desiredAttrValue = null;
        policyState.verified         = false;
        policyState.attrValue        = null;
        policyState.acceptanceId     = null;
        policyState.lang             = parts[1] || 'en';
        policyState._restoredAttr    = val;  /* mémoriser pour optimiser le prochain save */
        syncAllCheckboxes(false);
        console.log('[dtail-policy] restore: attr trouvé mais checkbox reset — action manuelle requise. id=' + parts[4]);
      } else {
        policyState.desiredAccepted  = false; policyState.desiredAttrValue = null;
        policyState.verified         = false; policyState.attrValue = null; policyState.acceptanceId = null;
        syncAllCheckboxes(false);
      }
      policyState.initialized = true;
    }).catch(function (err) {
      console.error('[dtail-policy] restore cartRead:', err);
      policyState.initialized = true;
    });

    policyState.restorePromise.then(function () {
      if (callback) callback();
    }).catch(function () { if (callback) callback(); });
  }

  /* ── ENDPOINT EXTERNE (fail-soft) ────────────────────────────────── */
  /* [FIX 1] Tout dérivé de attrValue via parseAcceptanceAttr()          */
  /* [FIX 2] Appelé uniquement via confirmFinalAcceptance()              */
  function sendExternal(attrValue) {
    var parsed = parseAcceptanceAttr(attrValue);
    if (!parsed) {
      console.error('[dtail-policy] sendExternal: attrValue invalide');
      return;
    }
    var t = TEXTS[parsed.language] || TEXTS.en;
    fetch(EXT_ENDPOINT, {
      method:    'POST',
      headers:   { 'Content-Type': 'application/json' },
      body:      JSON.stringify({
        acceptance_id:   parsed.acceptanceId,
        policy_key:      'shipping_policy',
        policy_version:  parsed.policyVersion,
        language:        parsed.language,
        acceptance_text: t.fullText,
        policy_url:      t.linkHref,
        accepted:        true,
        accepted_at:     parsed.acceptedAt,   /* [FIX 1] timestamp exact du cart attribute */
        source:          'cart_theme',
        is_dtc:          true,
        cart_attribute:  attrValue
      }),
      keepalive: true
    })
    .then(function (res) {
      if (!res.ok) {
        console.warn('[dtail-policy] sendExternal HTTP ' + res.status);
        throw new Error('HTTP ' + res.status);
      }
      return res.json();
    })
    .then(function (data) {
      console.log('[dtail-policy] sendExternal OK id:', parsed.acceptanceId, '| record:', data && data.id);
    })
    .catch(function (err) {
      console.warn('[dtail-policy] sendExternal \u00e9chec (non-bloquant):', err.message || err);
    });
  }

  /* ════════════════════════════════════════════════════════════════ */
  /* ── SIGNATURE + DÉPÔT v1.3 — module indépendant ───────────────── */
  /* Source de vérité : cart attribute _dtail_signature_authorization */
  /* Format v1.3 : authorized|LANG|v1.3|ISO_TS_NAVIGATEUR|dtsa_xxxxx   */
  /*              not_authorized|LANG|v1.3|ISO_TS_NAVIGATEUR|dtsa_xxx */
  /* authorized (dépôt sans signature) n'est VALIDE qu'accompagné de  */
  /*   _dtail_dropoff_location (code stable),                          */
  /*   _dtail_dropoff_details (texte ≤250),                            */
  /*   _dtail_dropoff_consent  (granted|LANG|v1.3|ISO|dtsa_id),       */
  /*   _dtail_signature_source (cart_page|cart_drawer).               */
  /* Les enregistrements v1.2 historiques gardent leur signification : */
  /*   authorized = dépôt sans signature autorisé (v1.2, sans lieu).   */
  /*   Ne JAMAIS réinterpréter une commande v1.2 avec les libellés v1.3*/
  /* État séparé de policyState — aucune interférence avec v1.1/v1.2.  */
  /* ════════════════════════════════════════════════════════════════ */
  var signatureState = {
    desiredChoice:     null,        /* 'authorized' | 'not_authorized' */
    desiredAttrValue:  null,
    verified:          false,
    attrValue:         null,
    authorizationId:   null,
    lang:              'en',
    operationVersion:  0,
    pendingOperation:  null,        /* { type, version } */
    isSaving:          false,
    lastGate:          null,        /* contexte (page/drawer) du dernier choix client */
    _pendingSubmit:    false,
    /* ── v1.3 — dépôt sans signature ── */
    desiredLocation:   null,        /* code interne : front_door|back_door|side_entrance|parcel_box|other */
    desiredDetails:    '',
    desiredConsent:    false,
    savedBundle:       null,        /* dernier bundle cohérent confirmé en cart */
    origin:            'cart_page'
  };

  function genSigId() {
    return 'dtsa_' + Math.random().toString(36).substring(2, 10) + '_' + Date.now().toString(36);
  }

  function buildSignatureAttrValue(lang, choice, id, ts) {
    return choice + '|' + lang + '|' + SIGNATURE_VERSION + '|' + ts + '|' + id;
  }

  function isValidSignatureAttr(val) {
    if (!val || typeof val !== 'string') return false;
    var parts = val.split('|');
    if (parts.length !== 5) return false;
    if (parts[0] !== 'authorized' && parts[0] !== 'not_authorized') return false;
    if (SUPPORTED_LANGS.indexOf(parts[1]) === -1) return false;   /* v1.3.3 : + de */
    /* v1.2 accepté en lecture (historique) — v1.3 en écriture/vérification */
    if (parts[2] !== 'v1.2' && parts[2] !== SIGNATURE_VERSION) return false;
    if (!ISO_REGEX.test(parts[3])) return false;
    if (isNaN(Date.parse(parts[3]))) return false;
    if (!DTSA_REGEX.test(parts[4])) return false;
    return true;
  }

  function isValidDropoffConsentAttr(val, id, lang) {
    if (!val || typeof val !== 'string') return false;
    var parts = val.split('|');
    if (parts.length !== 5) return false;
    if (parts[0] !== 'granted') return false;
    if (parts[1] !== lang) return false;
    if (parts[2] !== SIGNATURE_VERSION) return false;
    if (!ISO_REGEX.test(parts[3])) return false;
    if (parts[4] !== id) return false;
    return true;
  }

  /* v1.3.3 — libellés de lieu connus (toutes langues, codes inclus) : le filtre
     ne retire que les lignes de dépôt générées par le module, jamais une consigne
     libre du client portant le même préfixe. */
  var KNOWN_LOCATION_LABELS = (function () {
    var set = [];
    SUPPORTED_LANGS.forEach(function (lg) {
      var m = (SIG_TEXTS[lg] && SIG_TEXTS[lg].locationLabels) || {};
      Object.keys(m).forEach(function (code) {
        if (set.indexOf(m[code]) === -1) set.push(m[code]);
        if (set.indexOf(code) === -1) set.push(code);
      });
    });
    return set;
  })();

  /* Note opérative idempotente — exactement UNE ligne DELIVERY (et le cas
     échéant UNE ligne de dépôt), texte client préservé. v1.3.3 : phrases dans
     la langue de la commande, lieu traduit (plus de code), plus de REF dtsa_. */
  function computeDeliveryNote(existingNote, choice, bundle, lang) {
    var lg    = NOTE_TEXTS[lang] ? lang : 'en';   /* repli explicite EN */
    var note  = (existingNote || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var lines = note.split('\n').filter(function (l) {
      var t = l.trim();
      /* v1.3.1/v1.3.3 — retirer UNIQUEMENT les lignes opératives EXACTES du
         module : les 8 constantes YES/NO (4 langues), et les lignes de dépôt
         identifiées par un préfixe module connu + (référence dtsa_ en fin de
         ligne — historique — OU libellé de lieu connu — v1.3.3). Une consigne
         libre du client commençant par DELIVERY: est PRÉSERVÉE. */
      for (var k in NOTE_TEXTS) {
        if (t.toUpperCase() === NOTE_TEXTS[k].yes.toUpperCase()) return false;
        if (t.toUpperCase() === NOTE_TEXTS[k].no.toUpperCase())  return false;
      }
      for (var p in NOTE_TEXTS) {
        var pref = NOTE_TEXTS[p].drop;
        if (t.toUpperCase().indexOf(pref.toUpperCase()) === 0) {
          if (/\|\s*REF dtsa_[a-z0-9_]+$/i.test(t)) return false;   /* ligne historique */
          var rest = t.slice(pref.length).trim();
          for (var i = 0; i < KNOWN_LOCATION_LABELS.length; i++) {
            if (rest.toUpperCase().indexOf(KNOWN_LOCATION_LABELS[i].toUpperCase()) === 0) return false;
          }
        }
      }
      return true;
    });
    while (lines.length > 0 && lines[lines.length - 1].trim() === '') lines.pop();
    var result = lines.join('\n');
    if (result) result += '\n';
    if (choice === 'authorized' && bundle) {
      var drop = NOTE_TEXTS[lg].drop + locationLabel(bundle.location, lg);
      if (bundle.details) drop += ' | ' + bundle.details;
      return result + NOTE_TEXTS[lg].yes + '\n' + drop;
    }
    if (choice === 'revoke') return result;   /* révocation : aucune ligne réécrite */
    return result + NOTE_TEXTS[lg].no;
  }

  function locationLabel(code, lang) {
    var t = SIG_TEXTS[lang] || SIG_TEXTS.en;
    return (t.locationLabels && t.locationLabels[code]) || code;
  }

  function buildSignatureDisplayAttr(attrValue, bundle) {
    /* Version lisible EDT/EST pour Shopify Admin — style dtail_policy_display.
       L'horodatage provient du navigateur client (pas du serveur). */
    try {
      var parts = attrValue.split('|');
      if (parts.length < 5) return null;
      var choice = parts[0];
      var lang    = parts[1];
      var version = parts[2];
      var tsUtc   = parts[3];
      var id      = parts[4];
      var dtUtc   = new Date(tsUtc);
      var offset  = getEtOffset(dtUtc);
      var etMs    = dtUtc.getTime() + (offset * 60 * 60 * 1000);
      var etDate  = new Date(etMs);
      var tz      = (offset === -4) ? 'EDT' : 'EST';
      var pad     = function(n) { return String(n).padStart(2, '0'); };
      var fmtDate = etDate.getUTCFullYear() + '-'
                  + pad(etDate.getUTCMonth() + 1) + '-'
                  + pad(etDate.getUTCDate()) + ' '
                  + pad(etDate.getUTCHours()) + ':'
                  + pad(etDate.getUTCMinutes()) + ':'
                  + pad(etDate.getUTCSeconds()) + ' ' + tz;
      var head, tail;
      if (choice === 'authorized') {
        head = (lang === 'fr') ? 'Livraison sans signature autoris\u00e9e'
              : (lang === 'es') ? 'Entrega sin firma autorizada'
              : (lang === 'de') ? 'Lieferung ohne Unterschrift genehmigt'
              : 'No signature authorized';
        tail = (bundle)
          ? head + ' \u00b7 ' + locationLabel(bundle.location, lang)
            + (bundle.details ? ' \u00b7 ' + bundle.details : '')
            + ' \u00b7 '
          : head + ' \u00b7 ';
      } else {
        head = (lang === 'fr') ? 'Signature requise'
              : (lang === 'es') ? 'Firma requerida'
              : (lang === 'de') ? 'Unterschrift erforderlich'
              : 'Signature required';
        tail = head + ' \u00b7 ';
      }
      /* v1.3.3 — l'identifiant dtsa_ ne figure plus dans le champ lisible ;
         il reste dans _dtail_signature_authorization et dans la preuve archivée. */
      return tail + lang.toUpperCase() + ' \u00b7 ' + version + ' \u00b7 ' + fmtDate;
    } catch (e) { return null; }
  }

  function syncNoteFields(note) {
    /* Le champ note est soumis avec le formulaire checkout — il doit TOUJOURS
       refléter la dernière décision signature, sinon Shopify réécrirait la note
       serveur avec une valeur périmée au moment du submit /checkout. */
    if (typeof note !== 'string') return;
    document.querySelectorAll('textarea[name="note"], input[name="note"]').forEach(function (el) {
      if (el.value !== note) el.value = note;
    });
  }

  /* v1.3.1 — une saisie libre effectuée PENDANT une sauvegarde ne doit pas être
     écrasée par la note serveur au retour : on ne réécrit le DOM que si le
     client n'a rien modifié depuis le début de l'écriture. */
  function syncNoteFieldsIfUnchanged(note, snapshot) {
    if (typeof note !== 'string') return;
    document.querySelectorAll('textarea[name="note"], input[name="note"]').forEach(function (el) {
      if (String(el.value || '') === String(snapshot || '')) {
        if (el.value !== note) el.value = note;
      }
      /* sinon : le client a saisi pendant la sauvegarde — sa saisie DOM est conservée
         (elle partira avec le submit /checkout ou la prochaine écriture module) */
    });
  }

  function getNoteFieldFor(gate) {
    /* Remonte les ancêtres de la porte (page OU drawer) jusqu'à trouver le champ
       note du MÊME contexte — évite de lire le champ périmé d'un autre contexte
       (ex. drawer caché rendu côté serveur pendant une saisie sur la page). */
    var scope = gate && gate.parentElement ? gate : null;
    while (scope && scope !== document.body) {
      var f = scope.querySelector('textarea[name="note"], input[name="note"]');
      if (f) return f;
      scope = scope.parentElement;
    }
    return document.querySelector('textarea[name="note"], input[name="note"]');
  }

  function getCurrentNote(gate, cart) {
    /* Priorité au champ note du même contexte que la porte (saisie client non
       sauvegardée incluse), sinon note serveur. */
    var f = getNoteFieldFor(gate);
    if (f) return String(f.value || '');   /* v1.3.1 : champ vidé volontairement → vide, pas la note serveur */
    return (cart && cart.note) || '';
  }

  function originFor(gate) {
    var c = gate && gate.getAttribute ? gate.getAttribute('data-dtail-context') : '';
    return (c === 'drawer') ? 'cart_drawer' : 'cart_page';
  }

  function cartUpdateSig(attrValue, note, bundle, origin) {
    /* Attribut technique + lisible + bundle dépôt + note opérative en un seul appel */
    var attributes = {};
    attributes[SIG_ATTR_KEY] = attrValue;
    var display = buildSignatureDisplayAttr(attrValue, bundle);
    if (display) attributes[SIG_DISPLAY_KEY] = display;
    attributes[SIG_SOURCE_KEY] = origin || signatureState.origin;
    if (bundle) {
      attributes[DROP_ATTR_LOCATION] = bundle.location;
      attributes[DROP_ATTR_DETAILS]  = bundle.details || '';
      attributes[DROP_ATTR_CONSENT]  = 'granted|' + bundle.lang + '|' + SIGNATURE_VERSION
                                     + '|' + bundle.ts + '|' + bundle.id;
    } else {
      /* Choix AVEC signature → retirer toute autorisation de dépôt devenue inapplicable */
      attributes[DROP_ATTR_LOCATION] = '';
      attributes[DROP_ATTR_DETAILS]  = '';
      attributes[DROP_ATTR_CONSENT]  = '';
    }
    /* BRUT — toujours invoqué à l'intérieur d'une tâche sérialisée (queueCartWrite) */
    return fetch(cartUrl('/cart/update.js'), {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ note: note, attributes: attributes })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/update.js HTTP ' + res.status);
      return res.json();
    });
  }

  /* v1.3.1 — révocation : retire signature + bundle dépôt + lignes note du module.
     PAS une demande de signature : l'attr signature est VIDE, jamais not_authorized. */
  function cartUpdateSigRevoke(note) {
    var attributes = {};
    attributes[SIG_ATTR_KEY]       = '';
    attributes[SIG_DISPLAY_KEY]    = '';
    attributes[SIG_SOURCE_KEY]     = '';
    attributes[DROP_ATTR_LOCATION] = '';
    attributes[DROP_ATTR_DETAILS]  = '';
    attributes[DROP_ATTR_CONSENT]  = '';
    return queueCartWrite(function () {
      return fetch(cartUrl('/cart/update.js'), {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ note: note, attributes: attributes })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart/update.js HTTP ' + res.status);
        return res.json();
      });
    });
  }

  function syncSignatureChoices(value) {
    /* Sync page ↔ drawer — SÉLECTEUR SPÉCIFIQUE, indépendant de la checkbox policy */
    document.querySelectorAll('.dtail-signature-choice').forEach(function (r) {
      r.checked = !!value && r.value === value;
    });
  }

  /* ── DROP-OFF v1.3 — helpers DOM ──────────────────────────────────── */
  function activeGate() {
    if (signatureState.lastGate && document.body.contains(signatureState.lastGate)) {
      return signatureState.lastGate;
    }
    var gates = document.querySelectorAll('.dtail-policy-gate');
    return gates.length ? gates[0] : null;
  }

  function readDropoffInputs(gate) {
    gate = gate || activeGate();
    if (!gate) return { location: null, details: '', consent: false };
    var sel = gate.querySelector('.dtail-dropoff-location');
    var det = gate.querySelector('.dtail-dropoff-details');
    var con = gate.querySelector('.dtail-dropoff-consent');
    return {
      location: (sel && sel.value) ? sel.value : null,
      details: (det && !det.disabled) ? String(det.value || '').slice(0, DETAILS_MAX) : '',
      consent: !!(con && con.checked)
    };
  }

  /* v1.3.1 — champ précisions visible UNIQUEMENT pour 'other' */
  function cancelDetailsTimer(gate) {
    var det = gate.querySelector('.dtail-dropoff-details');
    if (det && det._dtailTimer) { clearTimeout(det._dtailTimer); det._dtailTimer = null; }
  }

  function syncDetailsVisibility(gate, location) {
    var wrap = gate.querySelector('.dtail-dropoff-details-wrap');
    var det  = gate.querySelector('.dtail-dropoff-details');
    if (!wrap || !det) return;
    var show = (DETAILS_VISIBLE_FOR.indexOf(location) !== -1);
    if (show) {
      wrap.classList.remove('dtail-hidden');
      det.disabled = false;
      det.setAttribute('aria-required', 'true');
    } else {
      wrap.classList.add('dtail-hidden');
      det.disabled = true;                 /* aucun blocage de validation invisible */
      det.removeAttribute('aria-required');
      det.value = '';                      /* précisions inapplicables vidées */
      if (det._dtailTimer) { clearTimeout(det._dtailTimer); det._dtailTimer = null; }
    }
    updateDetailsCounter(gate);
  }

  function isDropoffReady(info) {
    /* Bundle complet : lieu valide + précisions si obligatoires (refuse
       espaces seuls) + case d'autorisation cochée. */
    if (!info) return false;
    if (LOCATION_CODES.indexOf(info.location) === -1) return false;
    var d = (info.details || '').trim();
    if (DETAILS_REQUIRED_FOR.indexOf(info.location) !== -1 && d === '') return false;
    if (d.length > DETAILS_MAX) return false;
    return info.consent === true;
  }

  function clearDropoffFields(gate) {
    document.querySelectorAll('.dtail-policy-gate').forEach(function (g) {
      var sel = g.querySelector('.dtail-dropoff-location');
      var det = g.querySelector('.dtail-dropoff-details');
      var con = g.querySelector('.dtail-dropoff-consent');
      if (sel) sel.value = '';
      if (det) det.value = '';
      if (con) con.checked = false;
      syncDetailsVisibility(g, null);   /* v1.3.1 : champ précisions masqué + désactivé + timer annulé */
      var blk = g.querySelector('.dtail-dropoff-block');
      if (blk) blk.classList.remove('visible');
    });
    updateDetailsCounter(gate);
  }

  function syncDropoffUI() {
    /* Réplique l'état signatureState dans TOUS les gates (page + drawer) */
    var showBlock = (signatureState.desiredChoice === 'authorized');
    document.querySelectorAll('.dtail-policy-gate').forEach(function (g) {
      var blk = g.querySelector('.dtail-dropoff-block');
      var sel = g.querySelector('.dtail-dropoff-location');
      var det = g.querySelector('.dtail-dropoff-details');
      var con = g.querySelector('.dtail-dropoff-consent');
      if (blk) blk.classList.toggle('visible', showBlock);
      if (sel) sel.value = signatureState.desiredLocation || '';
      syncDetailsVisibility(g, showBlock ? (signatureState.desiredLocation || '') : null);
      if (!showBlock || DETAILS_VISIBLE_FOR.indexOf(signatureState.desiredLocation) === -1) {
        signatureState.desiredDetails = '';
      }
      if (det && det.value !== (signatureState.desiredDetails || '')) det.value = signatureState.desiredDetails || '';
      if (con) con.checked = !!signatureState.desiredConsent;
    });
    updateDetailsCounter(null);
  }

  function updateDetailsCounter(gate) {
    var info = readDropoffInputs(gate || activeGate());
    var n = (info.details || '').length;
    document.querySelectorAll('.dtail-policy-gate').forEach(function (g) {
      var c = g.querySelector('.dtail-dropoff-count');
      if (c) c.textContent = n + '/' + DETAILS_MAX;
      var det = g.querySelector('.dtail-dropoff-details');
      if (det) {
        var required = (info.location && DETAILS_REQUIRED_FOR.indexOf(info.location) !== -1);
        det.setAttribute('aria-required', required ? 'true' : 'false');
      }
    });
  }

  function showSignatureError(gate, type) {
    var errEl = gate.querySelector('.dtail-signature-error');
    if (errEl) {
      var t = SIG_TEXTS[signatureState.lang] || SIG_TEXTS.en;
      if (type === 'saving') {
        errEl.textContent = t.errorSaving;
        errEl.className   = 'dtail-signature-error visible saving';
      } else if (type === 'technical') {
        errEl.textContent = t.errorTechnical;
        errEl.className   = 'dtail-signature-error visible technical';
      } else {
        errEl.textContent = t.errorRequired;
        errEl.className   = 'dtail-signature-error visible';
      }
    }
  }

  function showDropoffError(gate, type) {
    var errEl = gate.querySelector('.dtail-dropoff-error');
    if (!errEl) { showSignatureError(gate, 'required'); return; }
    var t = SIG_TEXTS[signatureState.lang] || SIG_TEXTS.en;
    var msg = (type === 'location') ? t.errorLocation
            : (type === 'details')  ? t.errorDetails
            : (type === 'consent')  ? t.errorConsent
            : t.errorRequired;
    errEl.textContent = msg;
    errEl.className = 'dtail-dropoff-error visible';
    var con = gate.querySelector('.dtail-dropoff-consent');
    if (con) con.setAttribute('aria-invalid', 'true');
    var sel = gate.querySelector('.dtail-dropoff-location');
    if (sel) sel.setAttribute('aria-invalid', 'true');
  }

  function hideSignatureError(gate) {
    var errEl = gate.querySelector('.dtail-signature-error');
    if (errEl) errEl.className = 'dtail-signature-error';
  }

  function hideDropoffError(gate) {
    var errEl = gate && gate.querySelector ? gate.querySelector('.dtail-dropoff-error') : null;
    if (errEl) errEl.className = 'dtail-dropoff-error';
    document.querySelectorAll('.dtail-dropoff-consent').forEach(function (c) { c.removeAttribute('aria-invalid'); });
    document.querySelectorAll('.dtail-dropoff-location').forEach(function (s) { s.removeAttribute('aria-invalid'); });
  }

  /* ── RÉCAPITULATIF v1.3 — relu par le client avant de quitter le panier ── */
  function renderSummary(gate, choice, bundle) {
    document.querySelectorAll('.dtail-policy-gate').forEach(function (g) {
      var el = g.querySelector('.dtail-signature-summary');
      if (!el) return;
      el.textContent = '';
      var t = SIG_TEXTS[signatureState.lang] || SIG_TEXTS.en;
      if (choice === 'not_authorized') {
        var p1 = document.createElement('p');
        p1.className = 'dtail-summary-saved';
        p1.textContent = t.summarySaved + ' \u2014 ' + t.summarySignature;
        el.appendChild(p1);
      } else if (bundle) {
        var q1 = document.createElement('p');
        q1.className = 'dtail-summary-saved';
        q1.textContent = t.summarySaved + ' \u2014 ' + t.summaryDropoff;
        el.appendChild(q1);
        var q2 = document.createElement('p');
        q2.textContent = t.summaryLocation + ' : ' + locationLabel(bundle.location, signatureState.lang);
        el.appendChild(q2);
        if (bundle.details) {
          var q3 = document.createElement('p');
          q3.textContent = t.summaryDetails + ' : ' + bundle.details;
          el.appendChild(q3);
        }
        /* v1.3.2/v1.3.3 — la référence technique (dtsa_) n'apparaît ni dans le récapitulatif
           client ni dans la note opérative. Elle reste conservée : attr signature,
           dtail_signature.evidence (preuve archivée) et les champs techniques. */
      }
      el.classList.add('visible');
    });
  }

  function hideSummary() {
    document.querySelectorAll('.dtail-signature-summary').forEach(function (el) {
      el.classList.remove('visible');
      el.textContent = '';
    });
  }

  /* Réconciliation post-save signature — détecte une valeur Shopify != desired */
  function reconcileSignature(opVersion) {
    if (signatureState.operationVersion !== opVersion) return;
    cartRead().then(function (cart) {
      if (signatureState.operationVersion !== opVersion) return;
      var shopifyVal = cart.attributes && cart.attributes[SIG_ATTR_KEY];
      if (signatureState.desiredAttrValue && shopifyVal !== signatureState.desiredAttrValue) {
        console.warn('[dtail-signature] reconcile: valeur parasite d\u00e9tect\u00e9e \u2014 r\u00e9\u00e9criture');
        queueCartWrite(function () { return signatureWriteAndVerify(opVersion); }).then(function (result) {
          if (signatureState.operationVersion !== opVersion) return;
          signatureState.verified  = true;
          signatureState.attrValue = result.saved;
          syncNoteFieldsIfUnchanged(result.note, result.noteSnapshot);
          console.log('[dtail-signature] reconcile: OK');
        }).catch(function (err) {
          console.warn('[dtail-signature] reconcile \u00e9chec:', err);
          if (signatureState.operationVersion === opVersion) signatureState.verified = false;
        });
      }
    }).catch(function () { /* fail-soft */ });
  }

  function clearSigPendingOperation(version) {
    if (signatureState.pendingOperation && signatureState.pendingOperation.version === version) {
      signatureState.pendingOperation = null;
    }
  }

  function signatureWriteAndVerify(opVersion) {
    /* 1. lire la note actuelle → 2. écrire attr+display+bundle+note → 3. relire
       → 4. vérifier EXACT (attr + bundle dépôt lorsque authorized).
       v1.3.1 : id/ts/attrValue/bundle construits ICI, à l'exécution de la tâche
       sérialisée — dernière intention gagnante. Exécution TOUJOURS via queueCartWrite. */
    var newNote = '';
    var noteSnapshot = null;
    var lang   = signatureState.lang;
    var choice = signatureState.desiredChoice;
    if (choice !== 'authorized' && choice !== 'not_authorized') throw new Error('stale:no-choice');
    var id        = genSigId();
    var ts        = new Date().toISOString();  /* horodatage NAVIGATEUR, pas serveur */
    var attrValue = buildSignatureAttrValue(lang, choice, id, ts);
    var bundle    = null;
    if (choice === 'authorized') {
      bundle = {
        choice:   'authorized',
        location: signatureState.desiredLocation,
        details:  (signatureState.desiredDetails || '').trim().slice(0, DETAILS_MAX),
        consent:  true,
        id:       id,
        ts:       ts,
        lang:     lang,
        origin:   signatureState.origin
      };
      signatureState.desiredBundle = bundle;
    } else {
      signatureState.desiredBundle = null;
    }
    signatureState.desiredAttrValue = attrValue;
    signatureState.authorizationId  = id;
    return cartRead().then(function (cart) {
      if (signatureState.operationVersion !== opVersion) throw new Error('stale:read');
      noteSnapshot = getCurrentNote(signatureState.lastGate, cart);
      newNote = computeDeliveryNote(noteSnapshot, choice, bundle, lang);
      return cartUpdateSig(attrValue, newNote, bundle, signatureState.origin);
    }).then(function () {
      if (signatureState.operationVersion !== opVersion) throw new Error('stale:write');
      return cartRead();
    }).then(function (cart) {
      if (signatureState.operationVersion !== opVersion) throw new Error('stale:verify');
      var attrs = (cart && cart.attributes) || {};
      var saved = attrs[SIG_ATTR_KEY];
      if (saved !== signatureState.desiredAttrValue) throw new Error('mismatch:save');
      if (!isValidSignatureAttr(saved)) throw new Error('invalid:save');
      if (choice === 'authorized' && bundle) {
        /* Vérification complète du bundle dépôt — pas d'autorisation partielle */
        if (attrs[DROP_ATTR_LOCATION] !== bundle.location) throw new Error('mismatch:dropoff-location');
        if (String(attrs[DROP_ATTR_DETAILS] || '') !== (bundle.details || '')) throw new Error('mismatch:dropoff-details');
        if (!isValidDropoffConsentAttr(attrs[DROP_ATTR_CONSENT], bundle.id, bundle.lang)) throw new Error('mismatch:dropoff-consent');
      }
      if (choice === 'not_authorized') {
        if (attrs[DROP_ATTR_LOCATION] || attrs[DROP_ATTR_CONSENT]) throw new Error('mismatch:stale-dropoff');
      }
      return { saved: saved, note: newNote, noteSnapshot: noteSnapshot };
    });
  }

  function saveSignature(lang, choice, opVersion, gate, callback) {
    /* v1.3.1 — la valeur et le bundle sont construits AU MOMENT de l'exécution de
       la tâche sérialisée : si le client change d'avis pendant une requête, c'est
       sa DERNIÈRE intention qui est appliquée quand la requête se termine. */
    signatureState.lastGate         = gate || null;   /* contexte page ou drawer pour la lecture note */
    signatureState.origin           = originFor(gate);
    signatureState.pendingOperation = { type: 'save', version: opVersion };

    /* Réessais bornés (MAX_RETRY) — une requête ancienne ne peut JAMAIS écraser
       un choix plus récent : chaque étape vérifie signatureState.operationVersion. */
    var attempt = 0;
    var run = function () {
      attempt += 1;
      return signatureWriteAndVerify(opVersion).catch(function (err) {
        var msg = err && err.message ? err.message : String(err);
        if (msg.indexOf('stale:') === 0) throw err;   /* choix plus récent actif */
        if (attempt < MAX_RETRY) return run();
        throw err;
      });
    };

    queueCartWrite(run).then(function (result) {
      if (signatureState.operationVersion !== opVersion) {
        /* Confirmation tardive d'un choix périmé — le choix plus récent garde la main */
        if (callback) callback(new Error('stale:late'));
        return;
      }
      clearSigPendingOperation(opVersion);
      signatureState.verified    = true;
      signatureState.attrValue   = result.saved;
      signatureState.isSaving    = false;
      signatureState.savedBundle = signatureState.desiredBundle;
      syncNoteFieldsIfUnchanged(result.note, result.noteSnapshot);  /* saisie client pendant la sauvegarde préservée */
      renderSummary(gate, choice, signatureState.savedBundle);
      syncDropoffUI();   /* réplique lieu/précisions/case sur TOUS les gates (page ↔ tiroir) */
      if (callback) callback(null);
      /* Réconciliation post-save : une écriture périmée tardive (OUI après NON)
         serait détectée ici et réécrite — protection équivalente à la Règle C. */
      reconcileSignature(opVersion);
    }).catch(function (err) {
      clearSigPendingOperation(opVersion);
      console.error('[dtail-signature] saveSignature:', err);
      var msg = err && err.message ? err.message : String(err);
      if (msg.indexOf('stale:') === 0) {
        /* isSaving reste sous le contrôle du choix plus récent */
        if (callback) callback(err);
        return;
      }
      if (signatureState.operationVersion === opVersion) {
        signatureState.verified = false;
        signatureState.isSaving = false;
        hideSummary();
      }
      if (callback) callback(err);
    });
  }

  /* ── v1.3 — invalidation d'une autorisation incomplète/modifiée ── */
  function invalidateAuthorized() {
    /* v1.3.2 — toute invalidation programme une intention de nettoyage, Y COMPRIS
       pendant une première sauvegarde en cours (savedBundle encore vide MAIS
       l'écriture partie peut être arrivée dans le panier). La sauvegarde déjà
       partie peut se terminer : la décision nettoyage-ou-non est prise DANS la
       file sérialisée, donc TOUJOURS APRÈS toute écriture en vol, puis une
       relecture confirme l'absence de l'ancienne autorisation active.
       Une révocation ne devient JAMAIS une demande explicite de signature :
       l'attr signature est vidé, pas écrit à not_authorized. */
    var bundleWasSaved = !!signatureState.savedBundle;
    /* une écriture d'autorisation peut être en vol ou déjà partie même si
       savedBundle n'est pas encore rempli (première sauvegarde) */
    var writeMayBeActive = bundleWasSaved
      || !!signatureState.isSaving
      || !!signatureState.pendingOperation
      || !!signatureState.attrValue;
    signatureState.verified    = false;
    signatureState.attrValue   = null;
    signatureState.savedBundle = null;
    signatureState.desiredConsent = false;
    hideSummary();
    if (!writeMayBeActive) return;   /* rien n'a pu être écrit : rien à retirer */
    var opVersion = ++signatureState.operationVersion;
    signatureState.isSaving = true;
    /* La tâche entière passe dans la file sérialisée : la lecture du panier
       s'exécute APRÈS toute écriture en vol (première sauvegarde comprise). */
    queueCartWrite(function () {
      return cartRead().then(function (cart) {
        if (signatureState.operationVersion !== opVersion) throw new Error('stale:revoke-read');
        var aNow = (cart && cart.attributes) || {};
        var activePresent = !!(aNow[SIG_ATTR_KEY] || aNow[DROP_ATTR_CONSENT]
                           || aNow[DROP_ATTR_LOCATION] || aNow[DROP_ATTR_DETAILS]);
        if (!activePresent) return { skipped: true };   /* rien d'actif : relecture finale suffit */
        var noteNow = getCurrentNote(signatureState.lastGate, cart);
        /* écriture directe DANS la tâche sérialisée (pas d'emboîtement de file) */
        var attributes = {};
        attributes[SIG_ATTR_KEY]       = '';
        attributes[SIG_DISPLAY_KEY]    = '';
        attributes[SIG_SOURCE_KEY]     = '';
        attributes[DROP_ATTR_LOCATION] = '';
        attributes[DROP_ATTR_DETAILS]  = '';
        attributes[DROP_ATTR_CONSENT]  = '';
        return fetch(cartUrl('/cart/update.js'), {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify({ note: computeDeliveryNote(noteNow, 'revoke', null, signatureState.lang), attributes: attributes })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart/update.js HTTP ' + res.status);
          return { skipped: false };
        });
      });
    }).then(function () {
      if (signatureState.operationVersion !== opVersion) throw new Error('stale:revoke-write');
      return cartRead();
    }).then(function (cart) {
      if (signatureState.operationVersion !== opVersion) throw new Error('stale:revoke-verify');
      var a = (cart && cart.attributes) || {};
      if (a[SIG_ATTR_KEY]) throw new Error('revoke-failed:attr-present');
      if (a[DROP_ATTR_CONSENT]) throw new Error('revoke-failed:consent-present');
      return true;
    }).then(function () {
      if (signatureState.operationVersion !== opVersion) return;
      signatureState.isSaving = false;
      console.log('[dtail-signature] révocation confirmée — autorisation absente du panier');
    }).catch(function (err) {
      var msg = err && err.message ? err.message : String(err);
      if (msg.indexOf('stale:') === 0) return;   /* une intention plus récente gère l'état */
      signatureState.isSaving = false;
      console.error('[dtail-signature] révocation échouée:', err);
      if (signatureState.operationVersion === opVersion && signatureState.lastGate) {
        showSignatureError(signatureState.lastGate, 'technical');
      }
    });
  }

  function handleSignatureChange(gate, source, radioValue) {
    var lang = signatureState.lang;
    var opVersion = ++signatureState.operationVersion;
    signatureState.verified  = false;
    signatureState.attrValue  = null;

    if (source === 'radio') {
      var choice = radioValue;
      if (choice !== 'authorized' && choice !== 'not_authorized') return;
      signatureState.desiredChoice = choice;
      hideSignatureError(gate);
      hideDropoffError(gate);
      if (choice === 'not_authorized') {
        /* AVEC signature → retirer champs dépôt + autorisation, tout nettoyer */
        cancelDetailsTimer(gate);
        signatureState.desiredLocation = null;
        signatureState.desiredDetails  = '';
        signatureState.desiredConsent   = false;
        signatureState.desiredBundle    = null;
        signatureState.savedBundle      = null;
        syncSignatureChoices('not_authorized');
        clearDropoffFields(gate);
        hideSummary();
        signatureState.isSaving = true;
        saveSignature(lang, 'not_authorized', opVersion, gate, function (err) {
          if (err) {
            if (signatureState.operationVersion !== opVersion) return;
            showSignatureError(gate, 'technical');
            return;
          }
          hideSignatureError(gate);
          if (signatureState._pendingSubmit) {
            signatureState._pendingSubmit = false;
            var f = gate.closest('form');
            if (f && isCheckoutAllowed()) {
              var submitBtn = f.querySelector('[name="checkout"]');
              if (submitBtn) submitBtn.click();
            }
          }
        });
      } else {
        /* SANS signature → afficher les champs ; AUCUNE sauvegarde tant que le
           bundle n'est pas complet (lieu + [précisions si other] + autorisation). */
        cancelDetailsTimer(gate);
        syncSignatureChoices('authorized');
        syncDropoffUI();
        hideSummary();
        var sel = gate.querySelector('.dtail-dropoff-location');
        if (sel) sel.focus();
      }
      return;
    }

    /* ── sources : location | details | consent ── */
    cancelDetailsTimer(gate);
    if (source === 'location') {
      /* v1.3.1 — quitter 'other' vide les précisions (formulaire + état actif) ;
         revenir vers 'other' affiche un champ vide à compléter. */
      syncDetailsVisibility(gate, ((gate.querySelector('.dtail-dropoff-location') || {}).value) || null);
      if (DETAILS_VISIBLE_FOR.indexOf(((gate.querySelector('.dtail-dropoff-location') || {}).value) || '') === -1) {
        signatureState.desiredDetails = '';
      }
    }
    if (source === 'details') {
      var detEl2 = gate.querySelector('.dtail-dropoff-details');
      /* événement d'un champ devenu inapplicable (masqué/désactivé) → ignoré AVANT
         toute invalidation d'état */
      if (!detEl2 || detEl2.disabled || !gate.isConnected) { updateDetailsCounter(gate); return; }
    }
    var info = readDropoffInputs(gate);
    signatureState.desiredLocation = info.location;
    signatureState.desiredDetails  = info.details;
    signatureState.desiredConsent  = info.consent;

    if ((source === 'location' || source === 'details') && signatureState.savedBundle) {
      var sameAs = (signatureState.savedBundle.location === info.location)
        && (signatureState.savedBundle.details === (info.details || '').trim());
      if (!sameAs) {
        /* Lieu ou précisions modifiés APRÈS acceptation → l'autorisation
           précédente est invalidée : recocher la case pour re-confirmer.
           (savedBundle reste en place jusqu'à invalidateAuthorized, qui décide
           s'il y a un bundle sauvegardé à retirer du panier.) */
        signatureState.desiredConsent = false;
        info.consent = false;
        document.querySelectorAll('.dtail-dropoff-consent').forEach(function (c) { c.checked = false; });
        invalidateAuthorized();
      }
    }

    if (signatureState.desiredChoice === 'authorized' && isDropoffReady(info)) {
      hideSignatureError(gate);
      hideDropoffError(gate);
      updateDetailsCounter(gate);
      signatureState.isSaving = true;
      saveSignature(lang, 'authorized', opVersion, gate, function (err) {
        if (err) {
          if (signatureState.operationVersion !== opVersion) return;
          showSignatureError(gate, 'technical');
          return;
        }
        hideSignatureError(gate);
        hideDropoffError(gate);
        if (signatureState._pendingSubmit) {
          signatureState._pendingSubmit = false;
          var f = gate.closest('form');
          if (f && isCheckoutAllowed()) {
            var submitBtn = f.querySelector('[name="checkout"]');
            if (submitBtn) submitBtn.click();
          }
        }
      });
    } else {
      if (signatureState.desiredChoice === 'authorized' && !isDropoffReady(info)) {
        /* v1.3.2 — bundle sauvegardé OU première sauvegarde en cours : toute
           invalidation programme une intention de nettoyage (la tâche sérialisée
           relit le panier APRÈS l'écriture en vol et ne retire que l'existant). */
        invalidateAuthorized();
      }
      updateDetailsCounter(gate);
    }
  }

  /* ── CHECKOUT FAIL-CLOSED — politique v1.2 + signature/dépôt v1.3 ── */
  function isSignatureAnswered() {
    /* Vérification DOM physique : au moins un radio signature sélectionné */
    var anySelected = false;
    document.querySelectorAll('.dtail-signature-choice').forEach(function (r) {
      if (r.checked) anySelected = true;
    });
    return anySelected;
  }

  function getCheckedChoice() {
    var v = null;
    document.querySelectorAll('.dtail-signature-choice').forEach(function (r) {
      if (r.checked) v = r.value;
    });
    return v;
  }

  function isSignatureOk() {
    if (signatureState.isSaving) return false;              /* save signature en cours */
    if (!isSignatureAnswered()) return false;              /* aucune réponse physique */
    var domChoice = getCheckedChoice();
    if (domChoice !== 'authorized' && domChoice !== 'not_authorized') return false;
    var savedOk = (signatureState.desiredChoice === domChoice)
      && signatureState.verified === true
      && signatureState.desiredAttrValue !== null
      && signatureState.attrValue === signatureState.desiredAttrValue
      && isValidSignatureAttr(signatureState.attrValue);
    if (!savedOk) return false;
    if (domChoice === 'not_authorized') return true;
    /* authorized — le bundle dépôt complet doit être sauvegardé ET toujours
       reflété par les champs visibles (aucune divergence DOM/sauvegarde). */
    var info = readDropoffInputs(null);
    if (!isDropoffReady(info)) return false;
    var b = signatureState.savedBundle;
    if (!b) return false;
    if (b.location !== info.location) return false;
    if (b.details !== (info.details || '').trim()) return false;
    return true;
  }

  function isCheckoutAllowed() {
    if (policyState.isSaving || signatureState.isSaving) return false;  /* save en cours */
    /* Vérification DOM physique : au moins une checkbox doit être cochée */
    var anyChecked = false;
    document.querySelectorAll('.dtail-policy-checkbox').forEach(function(c) {
      if (c.checked) anyChecked = true;
    });
    if (!anyChecked) return false;
    if (!(policyState.desiredAccepted === true
        && policyState.verified === true
        && policyState.desiredAttrValue !== null
        && policyState.attrValue === policyState.desiredAttrValue
        && isValidAttr(policyState.attrValue))) return false;
    /* Signature/dépôt v1.3 — fail-closed : les DEUX décisions sont requises */
    return isSignatureOk();
  }

  /* v1.3.1 — le panier SERVEUR doit refléter exactement le dernier choix */
  function finalCartMatches(cart) {
    var a = (cart && cart.attributes) || {};
    if (a[ATTR_KEY] !== policyState.attrValue) return false;
    var domChoice = getCheckedChoice();
    if (domChoice === 'not_authorized') {
      return a[SIG_ATTR_KEY] === signatureState.attrValue;
    }
    if (domChoice === 'authorized') {
      if (a[SIG_ATTR_KEY] !== signatureState.attrValue) return false;
      var b = signatureState.savedBundle;
      if (!b) return false;
      if (a[DROP_ATTR_LOCATION] !== b.location) return false;
      if (String(a[DROP_ATTR_DETAILS] || '') !== (b.details || '')) return false;
      if (!isValidDropoffConsentAttr(a[DROP_ATTR_CONSENT], b.id, b.lang)) return false;
      return true;
    }
    return false;
  }

  /* ── BIND GATE → FORM PARENT ─────────────────────────────────────── */
  function bindGateToForm(gate, cb, context) {
    var form = gate.closest('form');
    if (!form) {
      var candidates = document.querySelectorAll('form[action*="/cart"]');
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].contains(gate)) { form = candidates[i]; break; }
      }
    }
    if (!form) {
      console.warn('[dtail-policy] aucun formulaire parent pour context=' + context);
      return;
    }
    var formFlagKey = '_dtailForm_' + context;
    var btnFlagKey  = '_dtailBtn_'  + context;
    var btn         = form.querySelector('[name="checkout"]');

    if (!form[formFlagKey]) {
      form[formFlagKey] = true;
      form.addEventListener('submit', function (e) {
        /* v1.3.1 — laissez-passer consommé par la confirmation finale */
        if (form._dtailFinalOk) { form._dtailFinalOk = false; return; }
        if (!isCheckoutAllowed()) {
          blockEvent(e);
          blockFeedback(gate, cb);
          return false;
        }
        /* Tout est cohérent en mémoire → confirmation FINALE : relire le panier et
           exiger le dernier choix + bundle correspondant AVANT de laisser partir
           le checkout. Échec réseau → bloqué (fail-closed) avec réessai possible. */
        blockEvent(e);
        if (form._dtailFinalBusy) return false;
        form._dtailFinalBusy = true;
        cartRead().then(function (cart) {
          form._dtailFinalBusy = false;
          if (finalCartMatches(cart)) {
            form._dtailFinalOk = true;   /* laisse passer le submit relancé */
            var sb = form.querySelector('[name="checkout"]');
            if (sb) sb.click(); else form.submit();
            return;
          }
          /* Divergence panier/mémoire → réécrire la dernière intention puis réessayer */
          console.warn('[dtail-signature] divergence finale panier — réécriture de la dernière intention');
          var v = ++signatureState.operationVersion;
          var dc = getCheckedChoice();
          signatureState.isSaving = true;
          saveSignature(signatureState.lang, dc || signatureState.desiredChoice, v, gate, function (err) {
            signatureState.isSaving = false;
            if (!err) {
              var sb2 = form.querySelector('[name="checkout"]');
              if (sb2 && isCheckoutAllowed()) {
                form._dtailFinalOk = true;
                sb2.click();
              }
            } else if (signatureState.operationVersion === v) {
              showSignatureError(gate, 'technical');
            }
          });
        }).catch(function () {
          form._dtailFinalBusy = false;
          showSignatureError(gate, 'technical');
          gate.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        return false;
      }, true);
    }

    if (btn && !btn[btnFlagKey]) {
      btn[btnFlagKey] = true;
      btn.addEventListener('click', function (e) {
        if (!isCheckoutAllowed()) {
          blockEvent(e);
          if (policyState.isSaving) {
            policyState._pendingSubmit = true;
            showError(gate, 'saving');
            gate.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else if (signatureState.isSaving) {
            signatureState._pendingSubmit = true;
            showSignatureError(gate, 'saving');
            gate.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            blockFeedback(gate, cb);
          }
          return false;
        }
      }, true);
    }
  }

  /* ── BLOCAGE CHECKOUT — message selon le bloqueur (policy vs signature/dépôt) ── */
  function blockFeedback(gate, cb) {
    var policyOk = cb.checked && policyState.desiredAccepted === true && policyState.verified === true;
    if (!policyOk) {
      showError(gate, (!policyState.desiredAccepted || !cb.checked) ? 'required' : 'technical');
      gate.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (!cb.checked) cb.focus();
      return;
    }
    /* Policy OK → le bloqueur est la signature ou le dépôt */
    var info = readDropoffInputs(gate);
    if (!isSignatureAnswered()) {
      showSignatureError(gate, 'required');
      var blk1 = gate.querySelector('.dtail-signature-block');
      if (blk1) blk1.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var firstRadio = gate.querySelector('.dtail-signature-choice');
      if (firstRadio) firstRadio.focus();
      return;
    }
    if (signatureState.desiredChoice === 'authorized' && !isDropoffReady(info)) {
      if (!info.location) {
        showDropoffError(gate, 'location');
        var sel = gate.querySelector('.dtail-dropoff-location');
        if (sel) { sel.focus(); gate.querySelector('.dtail-dropoff-block').scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      } else if (DETAILS_REQUIRED_FOR.indexOf(info.location) !== -1 && !(info.details || '').trim()) {
        showDropoffError(gate, 'details');
        var det = gate.querySelector('.dtail-dropoff-details');
        if (det) { det.focus(); det.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      } else {
        showDropoffError(gate, 'consent');
        var con = gate.querySelector('.dtail-dropoff-consent');
        if (con) { con.focus(); con.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }
      return;
    }
    showSignatureError(gate, 'technical');
    var blk2 = gate.querySelector('.dtail-signature-block');
    if (blk2) blk2.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ── INIT GATE ───────────────────────────────────────────────────── */
  function initGate(gate) {
    if (gate._dtailInit) return;
    gate._dtailInit = true;

    var context = gate.getAttribute('data-dtail-context') || 'page';
    var lang    = normalizeLang(gate.getAttribute('data-lang'));
    if (gate.getAttribute('data-lang-fallback') === 'true') {
      console.warn('[dtail-policy] locale non prise en charge — repli explicite EN : le texte affiché au client est l\u2019anglais, la langue enregistr\u00e9e est EN.');
    }
    var cb      = gate.querySelector('.dtail-policy-checkbox');
    if (!cb) return;

    policyState.lang = lang;
    signatureState.lang = lang;
    document.body.classList.add('dtail-dtc-active');

    /* 1. Bind immédiat — fail-closed dès maintenant */
    bindGateToForm(gate, cb, context);

    /* 2. Listener change IMMÉDIAT — avant ensureRestored */
    cb.addEventListener('change', function () {
      policyState.operationVersion += 1;
      var currentVersion           = policyState.operationVersion;
      policyState.desiredAccepted  = cb.checked;

      if (!cb.checked) {
        policyState.desiredAttrValue = null;
        policyState.acceptanceId     = null;
      }

      syncAllCheckboxes(cb.checked);

      if (cb.checked) {
        hideError(gate);
        policyState.isSaving = true;
        saveToCart(lang, currentVersion, function (err) {
          policyState.isSaving = false;
          if (err) {
            if (policyState.operationVersion !== currentVersion) return;
            policyState.desiredAccepted  = false;
            policyState.desiredAttrValue = null;
            policyState.verified         = false;
            syncAllCheckboxes(false);
            showError(gate, 'technical');
          } else {
            hideError(gate);
            if (policyState._pendingSubmit) {
              policyState._pendingSubmit = false;
              var f = gate.closest('form');
              if (f && isCheckoutAllowed()) {
                var submitBtn = f.querySelector('[name="checkout"]');
                if (submitBtn) submitBtn.click();
              }
            }
          }
        });
      } else {
        clearFromCart(currentVersion, function (err) {
          if (err) console.warn('[dtail-policy] clearFromCart non-critique:', err);
        });
      }
    });

    /* ── SIGNATURE + DÉPÔT v1.3 — init dans le même gate, état indépendant ── */
    gate.querySelectorAll('.dtail-signature-choice').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        if (!gate.isConnected) return;   /* v1.3.1 : nœud retiré par un re-rendu AJAX → ignoré */
        handleSignatureChange(gate, 'radio', radio.value);
      });
    });
    var selEl = gate.querySelector('.dtail-dropoff-location');
    if (selEl) selEl.addEventListener('change', function () {
      if (!gate.isConnected) return;
      hideDropoffError(gate);
      handleSignatureChange(gate, 'location');
    });
    var detEl = gate.querySelector('.dtail-dropoff-details');
    if (detEl) {
      detEl.addEventListener('change', function () {
        if (!gate.isConnected || detEl.disabled) return;   /* champ inapplicable → ignoré */
        hideDropoffError(gate);
        handleSignatureChange(gate, 'details');
      });
      detEl.addEventListener('input', function () {
        if (!gate.isConnected || detEl.disabled) return;   /* v1.3.1 : aucun timer sur un champ masqué */
        updateDetailsCounter(gate);
        if (detEl._dtailTimer) clearTimeout(detEl._dtailTimer);
        detEl._dtailTimer = setTimeout(function () {
          if (!gate.isConnected || detEl.disabled) return;
          handleSignatureChange(gate, 'details');
        }, 400);
      });
    }
    var conEl = gate.querySelector('.dtail-dropoff-consent');
    if (conEl) conEl.addEventListener('change', function () {
      if (!gate.isConnected) return;
      hideDropoffError(gate);
      handleSignatureChange(gate, 'consent');
    });

    /* Restauration de session (rendu AJAX du tiroir) : aucune présélection
       automatique sur simple attribut ancien (philosophie de consentement) —
       mais l'état de session en cours est réappliqué aux nouveaux nodes. */
    if (signatureState.operationVersion > 0 && signatureState.desiredChoice) {
      syncSignatureChoices(signatureState.desiredChoice);
      syncDropoffUI();
      if (signatureState.verified && signatureState.savedBundle) {
        renderSummary(gate, signatureState.desiredChoice, signatureState.savedBundle);
      }
    }

    /* 3. ensureRestored — sync affichage uniquement si pas d'interaction récente */
    var versionAtInit = policyState.operationVersion;
    ensureRestored(function () {
      if (policyState.operationVersion !== versionAtInit) {
        console.log('[dtail-policy] ensureRestored: interaction r\u00e9cente, sync ignor\u00e9e');
        return;
      }
      cb.checked = policyState.desiredAccepted && policyState.verified;
    });
  }

  /* ── NETTOYAGE PANIER VIDE v1.3 ───────────────────────────────────── */
  /* Panier vidé (p.ex. après une commande) → les autorisations de dépôt de la
     commande précédée ne doivent PAS être réutilisables. On supprime UNIQUEMENT
     les attributs de ce module — jamais la note client ni les autres modules. */
  var sigCleanupBusy = false;
  var sigCleanupTimer = null;

  function resetSignatureMemory() {
    /* Un nouveau panier ne récupère PAS l'autorisation du panier précédent. */
    signatureState.desiredChoice    = null;
    signatureState.desiredLocation  = null;
    signatureState.desiredDetails   = '';
    signatureState.desiredConsent   = false;
    signatureState.desiredBundle    = null;
    signatureState.savedBundle      = null;
    signatureState.desiredAttrValue = null;
    signatureState.attrValue        = null;
    signatureState.verified         = false;
    signatureState.operationVersion += 1;
    syncSignatureChoices(null);
    hideSummary();
  }

  function scheduleCleanupCheck(delayMs) {
    if (sigCleanupTimer) clearTimeout(sigCleanupTimer);
    sigCleanupTimer = setTimeout(cleanupIfCartEmpty, delayMs || 800);
  }

  function cleanupIfCartEmpty() {
    /* v1.3.1 — ré-armable : se déclenche aussi sur passage AJAX du panier à
       zéro article (retrait depuis le tiroir), pas seulement au chargement. */
    if (sigCleanupBusy) return;
    sigCleanupBusy = true;
    cartRead().then(function (cart) {
      var item_count = (cart && cart.item_count) || 0;
      if (item_count !== 0) return;
      resetSignatureMemory();
      var a = (cart && cart.attributes) || {};
      if (a[SIG_ATTR_KEY] || a[DROP_ATTR_LOCATION] || a[DROP_ATTR_DETAILS] || a[DROP_ATTR_CONSENT] || a[SIG_SOURCE_KEY]) {
        var attrs = {};
        attrs[SIG_ATTR_KEY]        = '';
        attrs[SIG_DISPLAY_KEY]     = '';
        attrs[SIG_SOURCE_KEY]      = '';
        attrs[DROP_ATTR_LOCATION]  = '';
        attrs[DROP_ATTR_DETAILS]   = '';
        attrs[DROP_ATTR_CONSENT]   = '';
        return queueCartWrite(function () {
          return fetch(cartUrl('/cart/update.js'), {
            method:  'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body:    JSON.stringify({ attributes: attrs })
          }).then(function (res) {
            if (!res.ok) throw new Error('cart/update.js HTTP ' + res.status);
            return res.json();
          }).then(function () {
            return cartRead();
          }).then(function (cart2) {
            var a2 = (cart2 && cart2.attributes) || {};
            if (a2[SIG_ATTR_KEY]) throw new Error('cleanup-failed:attr-present');
            console.log('[dtail-signature] cleanup panier vide: autorisations de d\u00e9p\u00f4t retir\u00e9es et confirm\u00e9es');
          });
        });
      }
    }).catch(function (err) {
      console.warn('[dtail-signature] cleanup panier vide:', err && err.message ? err.message : err);
    }).then(function () { sigCleanupBusy = false; });
  }

  /* ── INIT GLOBAL ─────────────────────────────────────────────────── */
  function initAll() {
    document.querySelectorAll('.dtail-policy-gate').forEach(function (gate) {
      initGate(gate);
    });
    cleanupIfCartEmpty();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ── MUTATIONOBSERVER — tiroir dynamique ─────────────────────────── */
  if (typeof MutationObserver !== 'undefined') {
    var globalObs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('dtail-policy-gate')) {
            initGate(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.dtail-policy-gate').forEach(initGate);
          }
        });
      });
      /* v1.3.1 — re-rendu AJAX (retrait d'article, tiroir, panier) → vérifier
         le passage réel du panier à zéro article (débouncé). */
      if (mutations.length > 0) scheduleCleanupCheck(1500);
    });
    globalObs.observe(document.body, { childList: true, subtree: true });
  }

})();
